export default __webpack_public_path__ + "435170ffd37b6ed435a9187029b2f00e.svg";